import { doc, setDoc } from 'firebase/firestore';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { firestore } from '@/lib/firebase';

// Global Tablet Control settings. The event key is shared by every tablet and
// is the last segment of the QR payload (suiteId_singleKey_eventKey).
export const DEFAULT_EVENT_KEY = '20220820';

const configRef = doc(firestore, 'configs', 'tabletControl');

export type TabletControlConfig = {
  eventKey?: string;
};

export function useTabletControlConfig() {
  return useDocumentData(configRef);
}

/** Current event key, falling back to the default while loading / unset. */
export function useEventKey(): [string, boolean] {
  const [config, loading] = useTabletControlConfig();
  const eventKey = (config as TabletControlConfig | undefined)?.eventKey;
  return [eventKey && eventKey.trim() ? eventKey.trim() : DEFAULT_EVENT_KEY, loading];
}

export function setEventKey(eventKey: string) {
  return setDoc(configRef, { eventKey: eventKey.trim() }, { merge: true });
}
